/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { utilities } from '@weatherbug/common';

import { translate } from '../../../common/translation/translate';
import { reduxConnect } from '../../../common';
import { degreeSymbol } from '../../common/utilities/symbols/degree';
import { CurrentConditionIconDescription } from './styledComponents/currentConditionIconDescription';
import { CurrentConditionsSummary } from './styledComponents/currentConditionsSummary';
import { ObsFeelsLike } from './styledComponents/obsFeelsLike';
import { ObsHighLowContainer } from './styledComponents/obsHighLowContainer';
import { ObsHighLowDetails } from './styledComponents/obsHighLowDetails';
import { ObsSummaryLeftContainer } from './styledComponents/obsSummaryLeftContainer';
import { IStoreState } from '../../common/interfaces/types';

const { units: wbCommonUnits } = utilities;
const { temperatureUnitAbbreviations } = wbCommonUnits;
const defaultCurrentObsValue = '--';

interface CurrentConditionsSummaryWrapperProps {
    currentConditionsTemp: number | null;
    feelsLike: number | null;
    nowTempHigh: number | null;
    nowTempLow: number | null;
    tempUnitAbbrev: string | null;
    iconDescription: string | null;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { nowConditions, units } =  storeState;
    const { nowConditions: nowConditionsData } = nowConditions || {};
    
    const { 
        d: iconDescription, 
        ht: nowTempHigh,
        lt: nowTempLow,
        flt: feelsLike  } = nowConditionsData || {};
    
    const { tempUnit } = units;
    const tempUnitAbbrev = temperatureUnitAbbreviations[tempUnit as keyof typeof temperatureUnitAbbreviations];

    return {
        feelsLike,
        nowTempHigh,
        nowTempLow,
        tempUnitAbbrev,
        iconDescription
    };
};

const mapDispatchToProps = {};

export const CurrentConditionsSummaryWrapper = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(memo(({   
    feelsLike,
    nowTempHigh,
    nowTempLow,
    tempUnitAbbrev,
    iconDescription = defaultCurrentObsValue }: CurrentConditionsSummaryWrapperProps) => {

    const feelsLikeDisplay = Number.isFinite(feelsLike) ? `${feelsLike}${degreeSymbol}` : defaultCurrentObsValue;

    const temperatureHighDisplay = Number.isFinite(nowTempHigh) ? `${nowTempHigh}${tempUnitAbbrev}` : defaultCurrentObsValue;

    const temperatureLowDisplay = Number.isFinite(nowTempLow) ? `${nowTempLow}${tempUnitAbbrev}` : defaultCurrentObsValue;

    return (
        <CurrentConditionsSummary>
            <ObsSummaryLeftContainer>
                <ObsFeelsLike>{`${translate('feelsLike')} ${feelsLikeDisplay}`}</ObsFeelsLike>
                <ObsHighLowContainer>
                    <ObsHighLowDetails key='now_cond_obs_hi'>{`${translate('hi')} ${temperatureHighDisplay}`}</ObsHighLowDetails>
                    <ObsHighLowDetails key='now_cond_obs_lo'>{`${translate('lo')} ${temperatureLowDisplay}`}</ObsHighLowDetails>
                </ObsHighLowContainer>
            </ObsSummaryLeftContainer>
            <CurrentConditionIconDescription>
                {iconDescription}
            </CurrentConditionIconDescription>
        </CurrentConditionsSummary>
    );
}));

CurrentConditionsSummaryWrapper.displayName = 'CurrentConditionsBody';

